<template>
  <footer>
    <div class="text-center text-white pt-4 pt-lg-5 footer-content">
      <!-- <span class="d-inline-flex">&#8205;
        <font-awesome-icon :icon="['fas', 'globe-americas']" size="2x"/>
      </span> -->
      <!-- <b-dropdown id="dorpdown-lang" dropup :text="language" toggle-class="bg-transparent border-0 display-4" size="lg" >
        <b-dropdown-item v-for="(value,key) in languages" :key="key" @click="switchLang(key)">{{value}}</b-dropdown-item>
      </b-dropdown> -->
      <br>
      <b-img src="./images/logo-square.png" class="footer-logo"></b-img>
      <!-- <div class="social-icons mx-auto">
        <b-link :href="facebook" target="_blank">
          <b-img rounded class="social-icon" src="./images/icon-facebook.png"></b-img>
        </b-link>
        <b-link :href="twitter" target="_blank">
          <b-img rounded class="social-icon" src="./images/icon-twitter.png"></b-img>
        </b-link>
        <b-link :href="youtube" target="_blank">
          <b-img rounded class="social-icon" src="./images/icon-youtube.png"></b-img>
        </b-link>
        <b-link :href="instagram" target="_blank">
          <b-img rounded class="social-icon" src="./images/icon-instagram.png"></b-img>
        </b-link>
      </div> -->
      <b-container>
        <b-row class="mt-3 mt-lg-5 justify-content-center">
          <b-col cols="12" class="d-block d-lg-none">MULTIVERSE® is a registered trademark of Multiverse Entertainment LLC, registered in the U.S. Patent and Trademark Office.</b-col>
          <b-col cols="12" class="d-block d-lg-none">© 2025 Multiverse Entertainment LLC. All rights reserved.</b-col>
          <b-col v-if="$i18n.locale == 'zh'" cols="12" class="d-block d-lg-none">ICP:粤ICP备17134275号-1</b-col>
        </b-row>
        <p class="d-none d-lg-block">MULTIVERSE® is a registered trademark of Multiverse Entertainment LLC, registered in the U.S. Patent and Trademark Office.</p>
        <p class="d-none d-lg-block">© 2025 Multiverse Entertainment LLC. All rights reserved.</p>
        <p class="d-none d-lg-inline pl-5" v-if="$i18n.locale == 'zh'">ICP:粤ICP备17134275号-1</p>
      </b-container>
    </div>
  </footer>
</template>
<style lang="scss">
.social-icons{
  display: flex;
  justify-content: space-around;
  margin-top: 5rem;
  width: 13rem;
}
.social-icon{
  width:2rem;
}
.footer{
  &-content{
    left: 0;
    right: 0;
    height: 25rem;
    margin: auto;
    background: url(./images/footer-bg-m.png);
    background-size: cover;
  }
  &-logo{
    margin-top: 2rem;
    width: 8rem;
  }
}
@include media-breakpoint-up(lg) {
  .social-icons{
    margin-top: 5rem;
    width: 13rem;
  }
  .footer{
    &-content{
      height: 33rem;
      background: url(./images/footer-bg.png);
    }
    &-logo{
      margin-top: 4rem;
      width: 8rem;
    }
  }
}
</style>
<script>
import globle from "@/assets/globle.js"
import {loadLanguageAsync} from '@/setup/i18n-setup.js'
export default {
  data() {
    return {
      facebook: globle.facebook,
      twitter: globle.twitter,
      linkedin: globle.linkedin,
      instagram: globle.instagram,
      youtube: globle.youtube,
      languages: globle.languages,
    };
  },
  computed:{
      language(){
        return this.languages[this.$i18n.locale]
      },
  },
  methods: {
    switchLang(lang) {
      // this.$i18n.locale = e;
      loadLanguageAsync(lang);
      this.$localStorage.set('lang', lang);
    }
  },
  mounted: function () {
    // var lang = this.$localStorage.get('lang')||navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
    // lang = lang.substr(0, 2);//截取lang前2位字符
    // if(lang == 'zh'){
    //   this.$i18n.locale = 'zh';
    // }else{
    //   this.$i18n.locale = 'en';
    // }

    this.$i18n.locale = 'en';
  }
};
</script>
